<template>
  <div id="app" v-if="show">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
  </div>
</template>
<script>
import { fetchGetTmpUuid, fetchPixelReport, fetchGetUserDetail, fetchReportEvent } from '@/api'
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY } from './utils/constant'
import Cookies from 'js-cookie'
import { isCurLogin, login } from '@/components/login/login'
import { setCookieFbc, setCookieAdId, getPathLang, getAppInfo, setToufang, getTtPixelId } from './utils/base'
import { getPaypalSdk } from './utils/paypal'
import { isFacebookWebView, getParam, isTiktokWebView } from './utils/tools'


export default {
  name: 'App',
  data() {
    return {
      show: false
      // Define any global data properties here
    }
  },
  methods: {
    getUuidCallback(){
      this.show = true
      fetchGetUserDetail().catch((error) => {
        console.log('fetch user detail error:', error)
      })
      setTimeout(() => {
        fetchPixelReport({}, 'PageView')
        fetchReportEvent({ 
          type: 'show',
          position: 'pageView',
          ext: JSON.stringify({
            fbclid: getParam('fbclid') || '',
            isFb: +isFacebookWebView(),
          })
        })
      }, 100);
    },
    async getUuid(){
      try {
        if(Cookies.get(USER_ID_COOKIES_KEY)){
          this.getUuidCallback();
          return
        }
        await fetchGetTmpUuid()
        this.getUuidCallback();
      }catch (error) {
        console.error('Error fetching UUID:', error)
      }
    },
    reportFb(){  
      console.log('reportFb')
    }
  },
  mounted() {
    ttq.load(getTtPixelId())
    setToufang.apply(this);
    console.log('是否在fb中', isFacebookWebView())
    console.log('是否在tt中', isTiktokWebView())
    document.title = getAppInfo()?.name;
    setTimeout(() => {
      getPaypalSdk()
    }, 0);
    this.$i18n.locale = getPathLang()
    setCookieAdId();
    setCookieFbc();
    this.getUuid()
    isCurLogin.value = login.isLogin()

  }
}
</script>


<style lang="less">

</style>
